import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Button, InsidePageWrapper, OutsidePageWrapper } from "@parkschannel/ui";
import { MainBanner } from "./MainBanner";
import { ReservationSection } from "./ReservationSection";
import { FiltersSection } from "./FiltersSection";
import { PlannerChecklist } from "./PlannerChecklist";
import { TripPlannerProvider } from "./TripPlannerContext";
import { usePlanner } from "../../TripPlanner";
import { SaveButton } from "./TripPlannerAction";
import { useAuth } from "../../Auth/AuthContext";
import { signIn } from "next-auth/react";
import { useButtonsAnalytics } from "../../../utils";
export const CreateTripPlanner = ()=>{
    useButtonsAnalytics();
    const { useSession  } = useAuth();
    const session = useSession();
    const { useSaveTripPlanMutationQuery  } = usePlanner();
    const saveTripPlan = useSaveTripPlanMutationQuery();
    return /*#__PURE__*/ _jsx("div", {
        className: "w-full bg-[#5c7eb4]",
        children: /*#__PURE__*/ _jsx(OutsidePageWrapper, {
            children: /*#__PURE__*/ _jsxs(InsidePageWrapper, {
                className: "flex flex-col gap-6",
                children: [
                    /*#__PURE__*/ _jsx(MainBanner, {}),
                    /*#__PURE__*/ _jsx(ReservationSection, {}),
                    /*#__PURE__*/ _jsxs(TripPlannerProvider, {
                        onSavePlan: saveTripPlan.mutateAsync,
                        children: [
                            /*#__PURE__*/ _jsx(FiltersSection, {}),
                            /*#__PURE__*/ _jsx(PlannerChecklist, {
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "w-full mt-8 flex justify-end",
                                    children: session && session.data ? /*#__PURE__*/ _jsx(SaveButton, {}) : /*#__PURE__*/ _jsx(Button, {
                                        variant: "outline",
                                        onClick: ()=>signIn("cognito"),
                                        children: "Sign in to save your checklist"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
